import React, {FC} from 'react';
import classes from './HLIconButton.module.scss';

interface HLIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
}

const HLIconButton: FC<HLIconButtonProps> = ({
                                               icon,
                                               children,
                                               ...props
                                             }) => {

  return (
      <button
          className={classes.iconButton}
          {...props}
      >
        {icon}
      </button>
  );
};

export default HLIconButton;